import FolderNodeViewState from '../store/schema/FolderNodeViewState';
import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Action called to set moveToFolderNodeViewState in store.
 */
export default mutatorAction(
    'setMoveToFolderNodeViewState',
    (folderId: string, viewState: FolderNodeViewState) => {
        getStore().moveToFolderNodeViewStates.set(folderId, viewState);
    }
);
